import axios, { AxiosResponse } from "axios";
import { ApiError } from "../ApiError";
import apis from "../apis";

export class GetDataApiVersion implements IGetDataApiVersion
{
    public async execute(): Promise<IVersion>
    {
        try
        {
            const response = await axios.get<IVersion>(`${apis.dataApiBaseUrl}v1/Service/version`);
            return response.data;
        }
        catch (response)
        {
            throw ApiError.fromAxiosResponse(response as AxiosResponse);
        }
    }
}

export interface IGetDataApiVersion
{
    execute(): Promise<IVersion>;
}

export interface IVersion
{
    version: string;
}
